import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';

const ERROR_MESSAGES = {
  not_authorized: "This account doesn't have access to Howdy. Try a different sign-in or contact your administrator.",
  login_failed: "Something went wrong during sign-in. Please try again.",
};

export default function Login() {
  const params = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
  const error = params.get('error');
  const errorMessage = error ? ERROR_MESSAGES[error] || 'Sign-in failed. Please try again.' : null;

  return (
    <Container
      className="d-flex flex-column justify-content-center align-items-center text-center"
      style={{ minHeight: '100vh', maxWidth: '420px' }}
    >
      {errorMessage ? (
        <>
          <Alert variant="danger" className="w-100 text-start mb-4">
            {errorMessage}
          </Alert>
          <Button size="lg" variant="primary" href="/login" className="px-4 rounded-pill">
            Try again
          </Button>
        </>
      ) : (
        <>
          <p style={{ fontSize: '5rem', margin: 0, lineHeight: 1 }}>👋</p>
          <h1 className="display-3 fw-light mt-3 mb-2">Howdy</h1>
          <p className="lead text-muted mb-4">Glad you're here. Sign in to get started.</p>
          <Button size="lg" variant="primary" href="/login/passport" className="px-4 rounded-pill">
            Sign in
          </Button>
        </>
      )}
    </Container>
  );
}
